import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BankState } from '../actions/bank';

interface IPayloadOpenDrawer {
    isEditMode: boolean;
    bank?: BankState | undefined;
}

export interface IBankEditState {
    isDrawerOpen: boolean;
    isEditMode: boolean;
    currentBank: BankState | undefined;
}

const initialState: IBankEditState = {
    isDrawerOpen: false,
    isEditMode: false,
    currentBank: undefined
};

const bankEditSlice = createSlice({
    name: 'bankEdit',
    initialState,
    reducers: {
        openDrawer: (state: IBankEditState, action: PayloadAction<IPayloadOpenDrawer>) => {
            state.isDrawerOpen = true;
            state.isEditMode = action.payload.isEditMode || false;
            state.currentBank = action.payload.bank || undefined;
        },
        closeDrawer: (state) => {
            state.isDrawerOpen = false;
            state.isEditMode = false;
            state.currentBank = undefined;
        }
    }
});

export const { openDrawer, closeDrawer } = bankEditSlice.actions;
export default bankEditSlice.reducer;
